export { dropdownVariables as dropdownSearchInputVariables } from './dropdownVariables';
